import React, { useEffect, useState } from "react";
import BareIndicator from "components/leftPanel/components/BareIndicator";

import equlizerBackground from "assets/phase2/equalizer.png";

function LeftPanel({
  timestampArray,
  currentTime,
  currentTrack,
  // startingBareNumber = 0,
  bareSize,
}) {
  // const [currentTrack, setCurrentTrack] = useState(0);
  const [bottomPanelLeft, setBottomPanelLeft] = useState(0);
  const [size, setSize] = useState(bareSize);
  const [bareSizeInt, setBareSizeInt] = useState(0);

  const timestamps = [];
  for (let i = 0; i < timestampArray?.length - 1; i++) {
    timestamps.push({
      startTime: timestampArray[i],
      endTime: timestampArray[i + 1],
    });
  }

  useEffect(() => {
    if (size && currentTrack) {
      setBottomPanelLeft(-1 * currentTrack * parseInt(size.slice(0, -2)));
      setBareSizeInt(parseInt(size.slice(0, -2)));
    }
  }, []);

  useEffect(() => {
    setBottomPanelLeft(-1 * Math.max(currentTrack - 3, 0) * bareSizeInt);
  }, [currentTrack, bareSizeInt]);

  useEffect(() => {
    setBareSizeInt(parseInt(size?.slice(0, -2)));
  }, [size]);

  useEffect(() => {
    console.log("bareSizeInt:", bottomPanelLeft);
  }, [bottomPanelLeft]);

  return (
    <>
      <div
        style={{
          height: "30%",
          width: "100%",
          backgroundColor: "#222222",
          backgroundImage: `url(${equlizerBackground})`,
          backgroundSize: "contain",
          // backgroundClip: "content-box",
        }}
      ></div>
      <div
        style={{
          display: "inline-flex",
          backgroundColor: "#222222",
          position: "relative",
          left: bottomPanelLeft,
          transition: "left 0.5s ease-in-out",
          // animation: "left ease-in-out 0.5s",
          // "-webkit-transition": "-webkit-transform .5s ease-in-out",
          // "-ms-transition": "-ms-transform .5s ease-in-out",
          // transition: "transform .5s ease-in-out",
        }}
      >
        {timestamps.map((timestamp, index) => {
          return (
            <div
              style={{
                height: bareSize,
                width: bareSize,
                padding: `${bareSizeInt / 7}px`,
                borderRightColor: "#c1995d80",
                borderRightWidth: "1.5px",
                borderRightStyle: "solid",
                borderTopColor: "#c1995d80",
                borderTopWidth: "1.5px",
                borderTopStyle: "solid",
                // boxShadow: "0px 0px 10px 0px ##f1795d70",
                
                
              }}
            >
              <BareIndicator
                bareNumber={index + 1}
                currentTime={currentTime}
                startTime={timestamp.startTime}
                endTime={timestamp.endTime}
                sepratorColor={"#222222"}
                totalBares={timestamps.length}
                size={`${bareSizeInt * 0.45}px`}
              />
            </div>
          );
        })}
      </div>
    </>
  );
}

// class LeftPanelClass extends React.Component {
//   constructor(props) {
//     super(props);

//     const timestamps = [];
//     for (let i = 0; i < this?.props?.timestamps?.length - 1; i++) {
//       timestamps.push({
//         startTime: this?.props?.timestamps[i],
//         endTime: this?.props?.timestamps[i + 1],
//       });
//     }
//     console.log("computedTimestamps:", timestamps);

//     this.state = {
//       currentTime: this.props.currentTime || 0,
//       timestamps: timestamps,
//       startingBareNumber: Math.max((this.props.startingBareNumber || 0) + 1, 1),
//       bareSize: this.props.bareSize || "50px",
//       bareSizeInt: parseInt(this.props.bareSize.slice(0, -2)) || 50,
//     };
//   }

//   componentDidMount() {
//     this.setState({
//       startingBareNumber: this.state.startingBareNumber,
//       bareSize: this.state.bareSize,
//       bareSizeInt: parseInt(this.state.bareSize.slice(0, -2)),
//       bottomPanelLeft: `${
//         -1 * this.state.startingBareNumber * this.state.bareSizeInt
//       }px`,
//     });
//   }
//   componentDidUpdate(prevProps, prevState) {
//     if (prevProps.currentTime !== this.props.currentTime) {
//       this.setState({
//         currentTime: prevProps.currentTime,
//         startingBareNumber: this.timestamps.filter((timestamp) => {
//           return timestamp.startTime <= this.props.currentTime;
//         }).length,
//       });
//     }
//   }

//   componentWillReceiveProps(nextProps) {
//     this.setState({
//       currentTime: nextProps.currentTime,
//       startingBareNumber: nextProps.startingBareNumber,
//       bareSize: nextProps.bareSize,
//       bareSizeInt: parseInt(nextProps.bareSize.slice(0, -2)),
//       bottomPanelLeft: `${
//         -1 * nextProps.startingBareNumber * nextProps.bareSizeInt
//       }px`,
//     });
//   }

//   render() {
//     return (
//       <>
//         <div
//           style={{ height: "30%", width: "100%", backgroundColor: "#222222" }}
//         ></div>
//         <div
//           style={{
//             display: "inline-flex",
//             backgroundColor: "#222222",
//             position: "relative",
//             left: this.state.bottomPanelLeft,
//           }}
//         >
//           {this.state.timestamps.map((timestamp, index) => {
//             return (
//               <div
//                 style={{
//                   height: this.state.bareSize,
//                   width: this.state.bareSize,
//                   padding: `${this.state.bareSizeInt / 7}px`,
//                   borderRightColor: "#f1a97d",
//                   borderRightWidth: "1.5px",
//                   borderRightStyle: "solid",
//                   borderTopColor: "#f1d97d",
//                   borderTopWidth: "1.5px",
//                   borderTopStyle: "solid",
//                 }}
//               >
//                 <BareIndicator
//                   bareNumber={index + 1}
//                   currentTime={this.state.currentTime}
//                   startTime={timestamp.startTime}
//                   endTime={timestamp.endTime}
//                   sepratorColor={"#222222"}
//                   size={`${this.state.bareSizeInt * 0.45}px`}
//                 />
//               </div>
//             );
//           })}
//         </div>
//       </>
//     );
//   }
// }

export default LeftPanel;
